import { Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';
import { BorderStyle, ButtonSize, ButtonStyle } from '../button-types';

@Component({
  selector: 'eg-icon-button',
  templateUrl: './icon-button.component.html',
  styleUrls: ['./icon-button.component.scss'],
  standalone: false,
})
export class IconButtonComponent {
  @Input() icon: string;
  @Input() iconClass: string;
  @Input() alt: string;
  @Input() egBorderStyle: BorderStyle = 'border';
  @Input() egButtonSize: ButtonSize = 'default';
  @Input() egStyle: ButtonStyle = 'primary';
  @Input() disabled: boolean;

  @Output() clicked: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();
  onIconClick(event: MouseEvent): void {
    this.clicked.emit(event);
    event.stopPropagation();
  }

  @HostBinding('class.eg-icon-button__primary') get buttonStylePrimary() {
    return this.egStyle === 'primary';
  }

  @HostBinding('class.eg-icon-button__none') get buttonStyleNone() {
    return this.egStyle === 'none';
  }

  @HostBinding('class.eg-icon-button__danger') get buttonStyleDanger() {
    return this.egStyle === 'danger';
  }

  @HostBinding('class.eg-icon-button__secondary') get buttonStyleSecondary() {
    return this.egStyle === 'secondary';
  }
}
